import React from 'react';
import { dashboard_breadcrumb, position_block } from '../../assets/img';
import { BreadCrumb } from '../../components';
import styles from './position-block.module.scss';
import { useHistory } from 'react-router-dom';

const breadCrumbList = [
  { name: 'Dashboard', icon: dashboard_breadcrumb, url: '/dashboard' },
  { name: 'Succession Planning Dashboard' },
];

const PositionBlock = () => {
  const history = useHistory();
  return (
    <>
      <div className={styles.maxWidth}>
        <div className={styles.control}>
          <BreadCrumb level={2} breadCrumbList={breadCrumbList} />
          <h3 className={styles.title}>Succession Planning Dashboard</h3>
          <div style={{ position: 'relative' }}>
            <img src={position_block} alt="" width="100%" />
            <div
              style={{
                position: 'absolute',
                fontWeight: '500',
                fontSize: '14px',
                lineHeight: '20px',
                color: 'transparent',
                fontFamily: `'Inter', sans-serif`,
                top: '65%',
                left: '61%',
                letterSpacing: '0.4px',
                transform: 'translate(-4px, -7px)',
                cursor: 'pointer',
              }}
              onKeyDown={() => {}}
              onClick={() => history.push('/succession-planning-page')}
            >
              Go
            </div>
            <div
              style={{
                position: 'absolute',
                fontWeight: '500',
                fontSize: '14px',
                lineHeight: '20px',
                color: 'transparent',
                fontFamily: `'Inter', sans-serif`,
                top: '67%',
                left: '49%',
                letterSpacing: '0.4px',
                transform: 'translate(-6px, -3px)',
                cursor: 'pointer',
              }}
              onKeyDown={() => {}}
              onClick={() => history.push('/succession-planning-page')}
            >
              back.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PositionBlock;
